(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["keepsake-name-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('la-keepsake-name-choice')) {
  class KeepsakeNameChoice extends HTMLElement {
    static choices = new Map();
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.radios = [...this.querySelectorAll('[data-name-choice]')];
      this.input = this.querySelector('[data-pet-name]');
      this.field = this.querySelector('[data-name-field]');
      this.noName = this.querySelector('[data-no-name-property]');
      this.error = this.querySelector('[role="alert"]');
      this.stateKey = this.dataset.productId + ':' + this.dataset.formId;
      const previous = KeepsakeNameChoice.choices.get(this.stateKey);
      if (previous) {
        this.radios.forEach(radio => { radio.checked = radio.value === previous.choice; });
        this.input.value = (previous.choice === 'Name' || previous.choice === 'Add Name') ? previous.name : '';
      }
      this.addEventListener('change', () => this.sync(), { signal });
      this.addEventListener('input', () => this.sync(), { signal });
      const validate = event => {
        if (this.valid()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.error.hidden = false;
        ((this.choice() === 'Name' || this.choice() === 'Add Name') ? this.input : this.radios[0]).focus();
      };
      document.addEventListener('submit', event => {
        if (event.target.getAttribute('id') === this.dataset.formId) validate(event);
      }, { capture:true, signal });
      document.addEventListener('click', event => {
        const button = event.target.closest('button[type="submit"], input[type="submit"]');
        if (button?.form?.getAttribute('id') === this.dataset.formId) validate(event);
      }, { capture:true, signal });
      document.addEventListener('formdata', event => {
        if (event.target.getAttribute('id') !== this.dataset.formId) return;
        const choice = this.choice();
        event.formData.set(this.radios[0].name, choice);
        if ((choice === 'Name' || choice === 'Add Name')) {
          event.formData.set(this.input.name, this.input.value.trim());
          event.formData.set(this.noName.name, 'No');
        } else {
          this.input.value = '';
          event.formData.delete(this.input.name);
          event.formData.set(this.noName.name, choice === 'No Name' ? 'Yes' : '');
        }
      }, { capture:true, signal });
      this.sync();
    }
    choice() { return this.radios.find(radio => radio.checked)?.value || ''; }
    valid() { return this.choice() === 'No Name' || ((this.choice() === 'Name' || this.choice() === 'Add Name') && this.input.value.trim().length > 0); }
    sync() {
      const choice = this.choice();
      const named = (choice === 'Name' || choice === 'Add Name');
      if (!named) this.input.value = '';
      this.field.hidden = !named;
      this.input.disabled = !named;
      this.input.required = named;
      this.noName.disabled = !choice;
      this.noName.value = choice === 'No Name' ? 'Yes' : 'No';
      const message = choice ? 'Please enter your pet’s name' : 'Please choose Name or No Name';
      this.input.setCustomValidity(named && !this.input.value.trim() ? message : '');
      this.error.textContent = message;
      if (this.valid()) this.error.hidden = true;
      KeepsakeNameChoice.choices.set(this.stateKey, { choice, name:named ? this.input.value : '' });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('la-keepsake-name-choice', KeepsakeNameChoice);
}
  } catch(e) { console.error(e); }
})();

})();
